import { TYPOGRAPHY } from "@/theme/typography"
import clsx, { ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": Object.keys(TYPOGRAPHY).flatMap(key => [`text-${key}-lg`, `text-${key}-md`, `text-${key}-sm`]),
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  const modifiedInputs = clsx(inputs)
  return twMerge(modifiedInputs)
}
